export function SET_DONT_SHOW_AGAIN(state, dontShowAgain) {
  state.dontShowAgainZelle = dontShowAgain;
}

export function INCREMENT_VIEW_COUNT(state) {
  state.viewCount += 1;
}